function $r(o, t, r) {
  const s = "virtual:storyblok-init", i = `\0${s}`;
  return {
    name: "vite-plugin-storyblok-init",
    async resolveId(l) {
      if (l === s)
        return i;
    },
    async load(l) {
      if (l === i)
        return `
          import { storyblokInit, apiPlugin } from "@storyblok/js";
          const { storyblokApi } = storyblokInit({
            accessToken: "${o}",
            use: ${t ? "[]" : "[apiPlugin]"},
            apiOptions: ${JSON.stringify(r)},
          });
          export const storyblokApiInstance = storyblokApi;  
        `;
    }
  };
}
const Or = /[\p{Lu}]/u, xr = /[\p{Ll}]/u, Me = /^[\p{Lu}](?![\p{Lu}])/gu, Je = /([\p{Alpha}\p{N}_]|$)/u, fe = /[_.\- ]+/, jr = new RegExp("^" + fe.source), Ne = new RegExp(fe.source + Je.source, "gu"), ze = new RegExp("\\d+" + Je.source, "gu"), Er = (o, t, r, s) => {
  let i = !1, l = !1, u = !1, f = !1;
  for (let g = 0; g < o.length; g++) {
    const y = o[g];
    f = g > 2 ? o[g - 3] === "-" : !0, i && Or.test(y) ? (o = o.slice(0, g) + "-" + o.slice(g), i = !1, u = l, l = !0, g++) : l && u && xr.test(y) && (!f || s) ? (o = o.slice(0, g - 1) + "-" + o.slice(g - 1), u = l, l = !1, i = !0) : (i = t(y) === y && r(y) !== y, u = l, l = r(y) === y && t(y) !== y);
  }
  return o;
}, Rr = (o, t) => (Me.lastIndex = 0, o.replaceAll(Me, (r) => t(r))), Lr = (o, t) => (Ne.lastIndex = 0, ze.lastIndex = 0, o.replaceAll(ze, (r, s, i) => ["_", "-"].includes(o.charAt(i + r.length)) ? r : t(r)).replaceAll(Ne, (r, s) => t(s)));
function Pr(o, t) {
  if (!(typeof o == "string" || Array.isArray(o)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (t = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...t
  }, Array.isArray(o) ? o = o.map((l) => l.trim()).filter((l) => l.length).join("-") : o = o.trim(), o.length === 0)
    return "";
  const r = t.locale === !1 ? (l) => l.toLowerCase() : (l) => l.toLocaleLowerCase(t.locale), s = t.locale === !1 ? (l) => l.toUpperCase() : (l) => l.toLocaleUpperCase(t.locale);
  return o.length === 1 ? fe.test(o) ? "" : t.pascalCase ? s(o) : r(o) : (o !== r(o) && (o = Er(o, r, s, t.preserveConsecutiveUppercase)), o = o.replace(jr, ""), o = t.preserveConsecutiveUppercase ? Rr(o, r) : r(o), t.pascalCase && (o = s(o.charAt(0)) + o.slice(1)), Lr(o, s));
}
function Fe(o) {
  return Pr(o);
}
function Mr(o, t = {}, r, s) {
  const i = "virtual:storyblok-components", l = `\0${i}`;
  return {
    name: "vite-plugin-storyblok-components",
    async resolveId(u) {
      if (u === i)
        return l;
    },
    async load(u) {
      if (u === l) {
        const f = [], g = [];
        for await (const [_, C] of Object.entries(t)) {
          const T = await this.resolve(
            `/${o}/${C}.astro`
          );
          if (T)
            f.push(`import ${Fe(_)} from "${T.id}"`);
          else if (r)
            g.push(_);
          else
            throw new Error(
              `Component could not be found for blok "${_}"! Does "${`/${o}/${C}`}.astro" exist?`
            );
        }
        let y = "";
        if (r)
          if (y = ",FallbackComponent", s) {
            const _ = await this.resolve(
              `/${o}/${s}.astro`
            );
            if (!_)
              throw new Error(
                `Custom fallback component could not be found. Does "${`/${o}/${s}`}.astro" exist?`
              );
            f.push(
              `import FallbackComponent from "${_.id}"`
            );
          } else
            f.push(
              "import FallbackComponent from '@storyblok/astro/FallbackComponent.astro'"
            );
        if (Object.values(t).length)
          return `${f.join(";")};export default {${Object.keys(t).filter((_) => !g.includes(_)).map((_) => Fe(_)).join(",")}${y}}`;
        if (r)
          return `${f[0]}; export default {${y.replace(",", "")}}`;
        throw new Error(
          `Currently, no Storyblok components are registered in astro.config.mjs.
Please register your components or enable the fallback component.
Detailed information can be found here: https://github.com/storyblok/storyblok-astro`
        );
      }
    }
  };
}
function Nr(o) {
  const t = "virtual:storyblok-options", r = `\0${t}`;
  return {
    name: "vite-plugin-storyblok-options",
    async resolveId(s) {
      if (s === t)
        return r;
    },
    async load(s) {
      if (s === r)
        return `export default ${JSON.stringify(o)}`;
    }
  };
}
let De = !1;
const Be = [], zr = (o) => new Promise((t, r) => {
  if (typeof window > "u" || (window.storyblokRegisterEvent = (i) => {
    if (window.location === window.parent.location) {
      console.warn("You are not in Draft Mode or in the Visual Editor.");
      return;
    }
    De ? i() : Be.push(i);
  }, document.getElementById("storyblok-javascript-bridge"))) return;
  const s = document.createElement("script");
  s.async = !0, s.src = o, s.id = "storyblok-javascript-bridge", s.onerror = (i) => r(i), s.onload = (i) => {
    Be.forEach((l) => l()), De = !0, t(i);
  }, document.getElementsByTagName("head")[0].appendChild(s);
});
var Fr = Object.defineProperty, Dr = (o, t, r) => t in o ? Fr(o, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[t] = r, S = (o, t, r) => Dr(o, typeof t != "symbol" ? t + "" : t, r);
let Br = class {
  constructor() {
    S(this, "isCDNUrl", (o = "") => o.includes("/cdn/")), S(this, "getOptionsPage", (o, t = 25, r = 1) => ({
      ...o,
      per_page: t,
      page: r
    })), S(this, "delay", (o) => new Promise((t) => setTimeout(t, o))), S(this, "arrayFrom", (o = 0, t) => Array.from({ length: o }, t)), S(this, "range", (o = 0, t = o) => {
      const r = Math.abs(t - o) || 0, s = o < t ? 1 : -1;
      return this.arrayFrom(r, (i, l) => l * s + o);
    }), S(this, "asyncMap", async (o, t) => Promise.all(o.map(t))), S(this, "flatMap", (o = [], t) => o.map(t).reduce((r, s) => [...r, ...s], [])), S(this, "escapeHTML", function(o) {
      const t = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, r = /[&<>"']/g, s = new RegExp(r.source);
      return o && s.test(o) ? o.replace(r, (i) => t[i]) : o;
    });
  }
  /**
   * @method stringify
   * @param  {object} params
   * @param  {string} prefix
   * @param  {boolean} isArray
   * @return {string} Stringified object
   */
  stringify(o, t, r) {
    const s = [];
    for (const i in o) {
      if (!Object.prototype.hasOwnProperty.call(o, i))
        continue;
      const l = o[i], u = r ? "" : encodeURIComponent(i);
      let f;
      typeof l == "object" ? f = this.stringify(
        l,
        t ? t + encodeURIComponent(`[${u}]`) : u,
        Array.isArray(l)
      ) : f = `${t ? t + encodeURIComponent(`[${u}]`) : u}=${encodeURIComponent(l)}`, s.push(f);
    }
    return s.join("&");
  }
  /**
   * @method getRegionURL
   * @param  {string} regionCode region code, could be eu, us, cn, ap or ca
   * @return {string} The base URL of the region
   */
  getRegionURL(o) {
    const t = "api.storyblok.com", r = "api-us.storyblok.com", s = "app.storyblokchina.cn", i = "api-ap.storyblok.com", l = "api-ca.storyblok.com";
    switch (o) {
      case "us":
        return r;
      case "cn":
        return s;
      case "ap":
        return i;
      case "ca":
        return l;
      default:
        return t;
    }
  }
};
const Ur = function(o, t) {
  const r = {};
  for (const s in o) {
    const i = o[s];
    t.includes(s) && i !== null && (r[s] = i);
  }
  return r;
}, Hr = (o) => o === "email", qr = () => ({
  singleTag: "hr"
}), Gr = () => ({
  tag: "blockquote"
}), Jr = () => ({
  tag: "ul"
}), Wr = (o) => ({
  tag: [
    "pre",
    {
      tag: "code",
      attrs: o.attrs
    }
  ]
}), Kr = () => ({
  singleTag: "br"
}), Zr = (o) => ({
  tag: `h${o.attrs.level}`
}), Vr = (o) => ({
  singleTag: [
    {
      tag: "img",
      attrs: Ur(o.attrs, ["src", "alt", "title"])
    }
  ]
}), Xr = () => ({
  tag: "li"
}), Yr = () => ({
  tag: "ol"
}), Qr = () => ({
  tag: "p"
}), en = (o) => ({
  tag: [
    {
      tag: "span",
      attrs: {
        "data-type": "emoji",
        "data-name": o.attrs.name,
        emoji: o.attrs.emoji
      }
    }
  ]
}), tn = () => ({
  tag: "b"
}), rn = () => ({
  tag: "s"
}), nn = () => ({
  tag: "u"
}), on = () => ({
  tag: "strong"
}), an = () => ({
  tag: "code"
}), sn = () => ({
  tag: "i"
}), ln = (o) => {
  if (!o.attrs)
    return {
      tag: ""
    };
  const t = new Br().escapeHTML, r = { ...o.attrs }, { linktype: s = "url" } = o.attrs;
  if (delete r.linktype, r.href && (r.href = t(o.attrs.href || "")), Hr(s) && (r.href = `mailto:${r.href}`), r.anchor && (r.href = `${r.href}#${r.anchor}`, delete r.anchor), r.custom) {
    for (const i in r.custom)
      r[i] = r.custom[i];
    delete r.custom;
  }
  return {
    tag: [
      {
        tag: "a",
        attrs: r
      }
    ]
  };
}, cn = (o) => ({
  tag: [
    {
      tag: "span",
      attrs: o.attrs
    }
  ]
}), un = () => ({
  tag: "sub"
}), fn = () => ({
  tag: "sup"
}), dn = (o) => ({
  tag: [
    {
      tag: "span",
      attrs: o.attrs
    }
  ]
}), pn = (o) => {
  var t;
  return (t = o.attrs) != null && t.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `background-color:${o.attrs.color};`
        }
      }
    ]
  } : {
    tag: ""
  };
}, gn = (o) => {
  var t;
  return (t = o.attrs) != null && t.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `color:${o.attrs.color}`
        }
      }
    ]
  } : {
    tag: ""
  };
}, hn = {
  nodes: {
    horizontal_rule: qr,
    blockquote: Gr,
    bullet_list: Jr,
    code_block: Wr,
    hard_break: Kr,
    heading: Zr,
    image: Vr,
    list_item: Xr,
    ordered_list: Yr,
    paragraph: Qr,
    emoji: en
  },
  marks: {
    bold: tn,
    strike: rn,
    underline: nn,
    strong: on,
    code: an,
    italic: sn,
    link: ln,
    styled: cn,
    subscript: un,
    superscript: fn,
    anchor: dn,
    highlight: pn,
    textStyle: gn
  }
}, bn = function(o) {
  const t = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  }, r = /[&<>"']/g, s = new RegExp(r.source);
  return o && s.test(o) ? o.replace(r, (i) => t[i]) : o;
};
let Ue = !1;
class yn {
  constructor(t) {
    S(this, "marks"), S(this, "nodes"), t || (t = hn), this.marks = t.marks || [], this.nodes = t.nodes || [];
  }
  addNode(t, r) {
    this.nodes[t] = r;
  }
  addMark(t, r) {
    this.marks[t] = r;
  }
  render(t, r = { optimizeImages: !1 }, s = !0) {
    if (!Ue && s && (console.warn(
      "Warning ⚠️: The RichTextResolver class is deprecated and will be removed in the next major release. Please use the `@storyblok/richtext` package instead. https://github.com/storyblok/richtext/"
    ), Ue = !0), t && t.content && Array.isArray(t.content)) {
      let i = "";
      return t.content.forEach((l) => {
        i += this.renderNode(l);
      }), r.optimizeImages ? this.optimizeImages(i, r.optimizeImages) : i;
    }
    return console.warn(
      `The render method must receive an Object with a "content" field.
      The "content" field must be an array of nodes as the type ISbRichtext.
      ISbRichtext:
        content?: ISbRichtext[]
        marks?: ISbRichtext[]
        attrs?: any
        text?: string
        type: string
        
        Example:
        {
          content: [
            {
              content: [
                {
                  text: 'Hello World',
                  type: 'text'
                }
              ],
              type: 'paragraph'
            }
          ],
          type: 'doc'
        }`
    ), "";
  }
  optimizeImages(t, r) {
    let s = 0, i = 0, l = "", u = "";
    typeof r != "boolean" && (typeof r.width == "number" && r.width > 0 && (l += `width="${r.width}" `, s = r.width), typeof r.height == "number" && r.height > 0 && (l += `height="${r.height}" `, i = r.height), (r.loading === "lazy" || r.loading === "eager") && (l += `loading="${r.loading}" `), typeof r.class == "string" && r.class.length > 0 && (l += `class="${r.class}" `), r.filters && (typeof r.filters.blur == "number" && r.filters.blur >= 0 && r.filters.blur <= 100 && (u += `:blur(${r.filters.blur})`), typeof r.filters.brightness == "number" && r.filters.brightness >= -100 && r.filters.brightness <= 100 && (u += `:brightness(${r.filters.brightness})`), r.filters.fill && (r.filters.fill.match(/[0-9A-F]{6}/gi) || r.filters.fill === "transparent") && (u += `:fill(${r.filters.fill})`), r.filters.format && ["webp", "png", "jpeg"].includes(r.filters.format) && (u += `:format(${r.filters.format})`), typeof r.filters.grayscale == "boolean" && r.filters.grayscale && (u += ":grayscale()"), typeof r.filters.quality == "number" && r.filters.quality >= 0 && r.filters.quality <= 100 && (u += `:quality(${r.filters.quality})`), r.filters.rotate && [90, 180, 270].includes(r.filters.rotate) && (u += `:rotate(${r.filters.rotate})`), u.length > 0 && (u = `/filters${u}`))), l.length > 0 && (t = t.replace(/<img/g, `<img ${l.trim()}`));
    const f = s > 0 || i > 0 || u.length > 0 ? `${s}x${i}${u}` : "";
    return t = t.replace(
      /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g,
      `a.storyblok.com/f/$1/$2.$3/m/${f}`
    ), typeof r != "boolean" && (r.sizes || r.srcset) && (t = t.replace(/<img.*?src=["|'](.*?)["|']/g, (g) => {
      var y, _;
      const C = g.match(
        /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g
      );
      if (C && C.length > 0) {
        const T = {
          srcset: (y = r.srcset) == null ? void 0 : y.map((w) => {
            if (typeof w == "number")
              return `//${C}/m/${w}x0${u} ${w}w`;
            if (typeof w == "object" && w.length === 2) {
              let x = 0, H = 0;
              return typeof w[0] == "number" && (x = w[0]), typeof w[1] == "number" && (H = w[1]), `//${C}/m/${x}x${H}${u} ${x}w`;
            }
            return "";
          }).join(", "),
          sizes: (_ = r.sizes) == null ? void 0 : _.map((w) => w).join(", ")
        };
        let $ = "";
        return T.srcset && ($ += `srcset="${T.srcset}" `), T.sizes && ($ += `sizes="${T.sizes}" `), g.replace(/<img/g, `<img ${$.trim()}`);
      }
      return g;
    })), t;
  }
  renderNode(t) {
    const r = [];
    t.marks && t.marks.forEach((i) => {
      const l = this.getMatchingMark(i);
      l && l.tag !== "" && r.push(this.renderOpeningTag(l.tag));
    });
    const s = this.getMatchingNode(t);
    return s && s.tag && r.push(this.renderOpeningTag(s.tag)), t.content ? t.content.forEach((i) => {
      r.push(this.renderNode(i));
    }) : t.text ? r.push(bn(t.text)) : s && s.singleTag ? r.push(this.renderTag(s.singleTag, " /")) : s && s.html ? r.push(s.html) : t.type === "emoji" && r.push(this.renderEmoji(t)), s && s.tag && r.push(this.renderClosingTag(s.tag)), t.marks && t.marks.slice(0).reverse().forEach((i) => {
      const l = this.getMatchingMark(i);
      l && l.tag !== "" && r.push(this.renderClosingTag(l.tag));
    }), r.join("");
  }
  renderTag(t, r) {
    return t.constructor === String ? `<${t}${r}>` : t.map((s) => {
      if (s.constructor === String)
        return `<${s}${r}>`;
      {
        let i = `<${s.tag}`;
        if (s.attrs) {
          for (const l in s.attrs)
            if (Object.prototype.hasOwnProperty.call(s.attrs, l)) {
              const u = s.attrs[l];
              u !== null && (i += ` ${l}="${u}"`);
            }
        }
        return `${i}${r}>`;
      }
    }).join("");
  }
  renderOpeningTag(t) {
    return this.renderTag(t, "");
  }
  renderClosingTag(t) {
    return t.constructor === String ? `</${t}>` : t.slice(0).reverse().map((r) => r.constructor === String ? `</${r}>` : `</${r.tag}>`).join("");
  }
  getMatchingNode(t) {
    const r = this.nodes[t.type];
    if (typeof r == "function")
      return r(t);
  }
  getMatchingMark(t) {
    const r = this.marks[t.type];
    if (typeof r == "function")
      return r(t);
  }
  renderEmoji(t) {
    if (t.attrs.emoji)
      return t.attrs.emoji;
    const r = [
      {
        tag: "img",
        attrs: {
          src: t.attrs.fallbackImage,
          draggable: "false",
          loading: "lazy",
          align: "absmiddle"
        }
      }
    ];
    return this.renderTag(r, " /");
  }
}
const mn = yn, Pn = (o) => {
  if (typeof o != "object" || typeof o._editable > "u")
    return {};
  try {
    const t = JSON.parse(
      o._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, "")
    );
    return t ? {
      "data-blok-c": JSON.stringify(t),
      "data-blok-uid": t.id + "-" + t.uid
    } : {};
  } catch {
    return {};
  }
};
let vn, _n = "https://app.storyblok.com/f/storyblok-v2-latest.js";
const wn = (o, t) => {
  o.addNode("blok", (r) => {
    let s = "";
    return r.attrs.body.forEach((i) => {
      s += t(i.component, i);
    }), {
      html: s
    };
  });
}, kn = (o) => !o || !(o != null && o.content.some((t) => t.content || t.type === "blok" || t.type === "horizontal_rule")), Tn = (o, t, r) => {
  let s = r || vn;
  if (!s) {
    console.error(
      "Please initialize the Storyblok SDK before calling the renderRichText function"
    );
    return;
  }
  return kn(o) ? "" : (t && (s = new mn(t.schema), t.resolver && wn(s, t.resolver)), s.render(o, {}, !1));
}, Mn = () => zr(_n);
function Cn(o) {
  const t = {
    resolveRelations: []
  };
  function r(s) {
    s && Array.isArray(t.resolveRelations) && t.resolveRelations.push(
      ...Array.isArray(s) ? s : [s]
    );
  }
  for (const s of o)
    if (s.options) {
      const { apiOptions: i, bridgeOptions: l } = s.options;
      if (r(i == null ? void 0 : i.resolve_relations), l) {
        const { resolveRelations: u, ...f } = l;
        r(u), Object.assign(t, f);
      }
    }
  return t.resolveRelations = [...new Set(t.resolveRelations)], t;
}
var Y = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function An(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var U = { exports: {} };
U.exports;
var He;
function Sn() {
  return He || (He = 1, function(o, t) {
    var r = 200, s = "__lodash_hash_undefined__", i = 800, l = 16, u = 9007199254740991, f = "[object Arguments]", g = "[object Array]", y = "[object AsyncFunction]", _ = "[object Boolean]", C = "[object Date]", T = "[object Error]", $ = "[object Function]", w = "[object GeneratorFunction]", x = "[object Map]", H = "[object Number]", We = "[object Null]", de = "[object Object]", Ke = "[object Proxy]", Ze = "[object RegExp]", Ve = "[object Set]", Xe = "[object String]", Ye = "[object Undefined]", Qe = "[object WeakMap]", et = "[object ArrayBuffer]", tt = "[object DataView]", rt = "[object Float32Array]", nt = "[object Float64Array]", ot = "[object Int8Array]", at = "[object Int16Array]", st = "[object Int32Array]", it = "[object Uint8Array]", lt = "[object Uint8ClampedArray]", ct = "[object Uint16Array]", ut = "[object Uint32Array]", ft = /[\\^$.*+?()[\]{}|]/g, dt = /^\[object .+?Constructor\]$/, pt = /^(?:0|[1-9]\d*)$/, b = {};
    b[rt] = b[nt] = b[ot] = b[at] = b[st] = b[it] = b[lt] = b[ct] = b[ut] = !0, b[f] = b[g] = b[et] = b[_] = b[tt] = b[C] = b[T] = b[$] = b[x] = b[H] = b[de] = b[Ze] = b[Ve] = b[Xe] = b[Qe] = !1;
    var pe = typeof Y == "object" && Y && Y.Object === Object && Y, gt = typeof self == "object" && self && self.Object === Object && self, M = pe || gt || Function("return this")(), ge = t && !t.nodeType && t, N = ge && !0 && o && !o.nodeType && o, he = N && N.exports === ge, Q = he && pe.process, be = function() {
      try {
        var e = N && N.require && N.require("util").types;
        return e || Q && Q.binding && Q.binding("util");
      } catch {
      }
    }(), ye = be && be.isTypedArray;
    function ht(e, n, a) {
      switch (a.length) {
        case 0:
          return e.call(n);
        case 1:
          return e.call(n, a[0]);
        case 2:
          return e.call(n, a[0], a[1]);
        case 3:
          return e.call(n, a[0], a[1], a[2]);
      }
      return e.apply(n, a);
    }
    function bt(e, n) {
      for (var a = -1, c = Array(e); ++a < e; )
        c[a] = n(a);
      return c;
    }
    function yt(e) {
      return function(n) {
        return e(n);
      };
    }
    function mt(e, n) {
      return e == null ? void 0 : e[n];
    }
    function vt(e, n) {
      return function(a) {
        return e(n(a));
      };
    }
    var _t = Array.prototype, wt = Function.prototype, q = Object.prototype, ee = M["__core-js_shared__"], G = wt.toString, O = q.hasOwnProperty, me = function() {
      var e = /[^.]+$/.exec(ee && ee.keys && ee.keys.IE_PROTO || "");
      return e ? "Symbol(src)_1." + e : "";
    }(), ve = q.toString, kt = G.call(Object), Tt = RegExp(
      "^" + G.call(O).replace(ft, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), J = he ? M.Buffer : void 0, _e = M.Symbol, we = M.Uint8Array;
    J && J.allocUnsafe;
    var ke = vt(Object.getPrototypeOf, Object), Te = Object.create, Ct = q.propertyIsEnumerable, At = _t.splice, j = _e ? _e.toStringTag : void 0, W = function() {
      try {
        var e = ne(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch {
      }
    }(), St = J ? J.isBuffer : void 0, Ce = Math.max, It = Date.now, Ae = ne(M, "Map"), z = ne(Object, "create"), $t = /* @__PURE__ */ function() {
      function e() {
      }
      return function(n) {
        if (!R(n))
          return {};
        if (Te)
          return Te(n);
        e.prototype = n;
        var a = new e();
        return e.prototype = void 0, a;
      };
    }();
    function E(e) {
      var n = -1, a = e == null ? 0 : e.length;
      for (this.clear(); ++n < a; ) {
        var c = e[n];
        this.set(c[0], c[1]);
      }
    }
    function Ot() {
      this.__data__ = z ? z(null) : {}, this.size = 0;
    }
    function xt(e) {
      var n = this.has(e) && delete this.__data__[e];
      return this.size -= n ? 1 : 0, n;
    }
    function jt(e) {
      var n = this.__data__;
      if (z) {
        var a = n[e];
        return a === s ? void 0 : a;
      }
      return O.call(n, e) ? n[e] : void 0;
    }
    function Et(e) {
      var n = this.__data__;
      return z ? n[e] !== void 0 : O.call(n, e);
    }
    function Rt(e, n) {
      var a = this.__data__;
      return this.size += this.has(e) ? 0 : 1, a[e] = z && n === void 0 ? s : n, this;
    }
    E.prototype.clear = Ot, E.prototype.delete = xt, E.prototype.get = jt, E.prototype.has = Et, E.prototype.set = Rt;
    function I(e) {
      var n = -1, a = e == null ? 0 : e.length;
      for (this.clear(); ++n < a; ) {
        var c = e[n];
        this.set(c[0], c[1]);
      }
    }
    function Lt() {
      this.__data__ = [], this.size = 0;
    }
    function Pt(e) {
      var n = this.__data__, a = K(n, e);
      if (a < 0)
        return !1;
      var c = n.length - 1;
      return a == c ? n.pop() : At.call(n, a, 1), --this.size, !0;
    }
    function Mt(e) {
      var n = this.__data__, a = K(n, e);
      return a < 0 ? void 0 : n[a][1];
    }
    function Nt(e) {
      return K(this.__data__, e) > -1;
    }
    function zt(e, n) {
      var a = this.__data__, c = K(a, e);
      return c < 0 ? (++this.size, a.push([e, n])) : a[c][1] = n, this;
    }
    I.prototype.clear = Lt, I.prototype.delete = Pt, I.prototype.get = Mt, I.prototype.has = Nt, I.prototype.set = zt;
    function L(e) {
      var n = -1, a = e == null ? 0 : e.length;
      for (this.clear(); ++n < a; ) {
        var c = e[n];
        this.set(c[0], c[1]);
      }
    }
    function Ft() {
      this.size = 0, this.__data__ = {
        hash: new E(),
        map: new (Ae || I)(),
        string: new E()
      };
    }
    function Dt(e) {
      var n = V(this, e).delete(e);
      return this.size -= n ? 1 : 0, n;
    }
    function Bt(e) {
      return V(this, e).get(e);
    }
    function Ut(e) {
      return V(this, e).has(e);
    }
    function Ht(e, n) {
      var a = V(this, e), c = a.size;
      return a.set(e, n), this.size += a.size == c ? 0 : 1, this;
    }
    L.prototype.clear = Ft, L.prototype.delete = Dt, L.prototype.get = Bt, L.prototype.has = Ut, L.prototype.set = Ht;
    function P(e) {
      var n = this.__data__ = new I(e);
      this.size = n.size;
    }
    function qt() {
      this.__data__ = new I(), this.size = 0;
    }
    function Gt(e) {
      var n = this.__data__, a = n.delete(e);
      return this.size = n.size, a;
    }
    function Jt(e) {
      return this.__data__.get(e);
    }
    function Wt(e) {
      return this.__data__.has(e);
    }
    function Kt(e, n) {
      var a = this.__data__;
      if (a instanceof I) {
        var c = a.__data__;
        if (!Ae || c.length < r - 1)
          return c.push([e, n]), this.size = ++a.size, this;
        a = this.__data__ = new L(c);
      }
      return a.set(e, n), this.size = a.size, this;
    }
    P.prototype.clear = qt, P.prototype.delete = Gt, P.prototype.get = Jt, P.prototype.has = Wt, P.prototype.set = Kt;
    function Zt(e, n) {
      var a = se(e), c = !a && ae(e), d = !a && !c && xe(e), h = !a && !c && !d && Ee(e), m = a || c || d || h, p = m ? bt(e.length, String) : [], v = p.length;
      for (var A in e)
        m && // Safari 9 has enumerable `arguments.length` in strict mode.
        (A == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        d && (A == "offset" || A == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        h && (A == "buffer" || A == "byteLength" || A == "byteOffset") || // Skip index properties.
        $e(A, v)) || p.push(A);
      return p;
    }
    function te(e, n, a) {
      (a !== void 0 && !X(e[n], a) || a === void 0 && !(n in e)) && re(e, n, a);
    }
    function Vt(e, n, a) {
      var c = e[n];
      (!(O.call(e, n) && X(c, a)) || a === void 0 && !(n in e)) && re(e, n, a);
    }
    function K(e, n) {
      for (var a = e.length; a--; )
        if (X(e[a][0], n))
          return a;
      return -1;
    }
    function re(e, n, a) {
      n == "__proto__" && W ? W(e, n, {
        configurable: !0,
        enumerable: !0,
        value: a,
        writable: !0
      }) : e[n] = a;
    }
    var Xt = ur();
    function Z(e) {
      return e == null ? e === void 0 ? Ye : We : j && j in Object(e) ? fr(e) : yr(e);
    }
    function Se(e) {
      return F(e) && Z(e) == f;
    }
    function Yt(e) {
      if (!R(e) || hr(e))
        return !1;
      var n = le(e) ? Tt : dt;
      return n.test(wr(e));
    }
    function Qt(e) {
      return F(e) && je(e.length) && !!b[Z(e)];
    }
    function er(e) {
      if (!R(e))
        return br(e);
      var n = Oe(e), a = [];
      for (var c in e)
        c == "constructor" && (n || !O.call(e, c)) || a.push(c);
      return a;
    }
    function Ie(e, n, a, c, d) {
      e !== n && Xt(n, function(h, m) {
        if (d || (d = new P()), R(h))
          tr(e, n, m, a, Ie, c, d);
        else {
          var p = c ? c(oe(e, m), h, m + "", e, n, d) : void 0;
          p === void 0 && (p = h), te(e, m, p);
        }
      }, Re);
    }
    function tr(e, n, a, c, d, h, m) {
      var p = oe(e, a), v = oe(n, a), A = m.get(v);
      if (A) {
        te(e, a, A);
        return;
      }
      var k = h ? h(p, v, a + "", e, n, m) : void 0, D = k === void 0;
      if (D) {
        var ce = se(v), ue = !ce && xe(v), Pe = !ce && !ue && Ee(v);
        k = v, ce || ue || Pe ? se(p) ? k = p : kr(p) ? k = ir(p) : ue ? (D = !1, k = or(v)) : Pe ? (D = !1, k = sr(v)) : k = [] : Tr(v) || ae(v) ? (k = p, ae(p) ? k = Cr(p) : (!R(p) || le(p)) && (k = dr(v))) : D = !1;
      }
      D && (m.set(v, k), d(k, v, c, h, m), m.delete(v)), te(e, a, k);
    }
    function rr(e, n) {
      return vr(mr(e, n, Le), e + "");
    }
    var nr = W ? function(e, n) {
      return W(e, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Sr(n),
        writable: !0
      });
    } : Le;
    function or(e, n) {
      return e.slice();
    }
    function ar(e) {
      var n = new e.constructor(e.byteLength);
      return new we(n).set(new we(e)), n;
    }
    function sr(e, n) {
      var a = ar(e.buffer);
      return new e.constructor(a, e.byteOffset, e.length);
    }
    function ir(e, n) {
      var a = -1, c = e.length;
      for (n || (n = Array(c)); ++a < c; )
        n[a] = e[a];
      return n;
    }
    function lr(e, n, a, c) {
      var d = !a;
      a || (a = {});
      for (var h = -1, m = n.length; ++h < m; ) {
        var p = n[h], v = void 0;
        v === void 0 && (v = e[p]), d ? re(a, p, v) : Vt(a, p, v);
      }
      return a;
    }
    function cr(e) {
      return rr(function(n, a) {
        var c = -1, d = a.length, h = d > 1 ? a[d - 1] : void 0, m = d > 2 ? a[2] : void 0;
        for (h = e.length > 3 && typeof h == "function" ? (d--, h) : void 0, m && pr(a[0], a[1], m) && (h = d < 3 ? void 0 : h, d = 1), n = Object(n); ++c < d; ) {
          var p = a[c];
          p && e(n, p, c, h);
        }
        return n;
      });
    }
    function ur(e) {
      return function(n, a, c) {
        for (var d = -1, h = Object(n), m = c(n), p = m.length; p--; ) {
          var v = m[++d];
          if (a(h[v], v, h) === !1)
            break;
        }
        return n;
      };
    }
    function V(e, n) {
      var a = e.__data__;
      return gr(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
    }
    function ne(e, n) {
      var a = mt(e, n);
      return Yt(a) ? a : void 0;
    }
    function fr(e) {
      var n = O.call(e, j), a = e[j];
      try {
        e[j] = void 0;
        var c = !0;
      } catch {
      }
      var d = ve.call(e);
      return c && (n ? e[j] = a : delete e[j]), d;
    }
    function dr(e) {
      return typeof e.constructor == "function" && !Oe(e) ? $t(ke(e)) : {};
    }
    function $e(e, n) {
      var a = typeof e;
      return n = n ?? u, !!n && (a == "number" || a != "symbol" && pt.test(e)) && e > -1 && e % 1 == 0 && e < n;
    }
    function pr(e, n, a) {
      if (!R(a))
        return !1;
      var c = typeof n;
      return (c == "number" ? ie(a) && $e(n, a.length) : c == "string" && n in a) ? X(a[n], e) : !1;
    }
    function gr(e) {
      var n = typeof e;
      return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
    }
    function hr(e) {
      return !!me && me in e;
    }
    function Oe(e) {
      var n = e && e.constructor, a = typeof n == "function" && n.prototype || q;
      return e === a;
    }
    function br(e) {
      var n = [];
      if (e != null)
        for (var a in Object(e))
          n.push(a);
      return n;
    }
    function yr(e) {
      return ve.call(e);
    }
    function mr(e, n, a) {
      return n = Ce(n === void 0 ? e.length - 1 : n, 0), function() {
        for (var c = arguments, d = -1, h = Ce(c.length - n, 0), m = Array(h); ++d < h; )
          m[d] = c[n + d];
        d = -1;
        for (var p = Array(n + 1); ++d < n; )
          p[d] = c[d];
        return p[n] = a(m), ht(e, this, p);
      };
    }
    function oe(e, n) {
      if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
        return e[n];
    }
    var vr = _r(nr);
    function _r(e) {
      var n = 0, a = 0;
      return function() {
        var c = It(), d = l - (c - a);
        if (a = c, d > 0) {
          if (++n >= i)
            return arguments[0];
        } else
          n = 0;
        return e.apply(void 0, arguments);
      };
    }
    function wr(e) {
      if (e != null) {
        try {
          return G.call(e);
        } catch {
        }
        try {
          return e + "";
        } catch {
        }
      }
      return "";
    }
    function X(e, n) {
      return e === n || e !== e && n !== n;
    }
    var ae = Se(/* @__PURE__ */ function() {
      return arguments;
    }()) ? Se : function(e) {
      return F(e) && O.call(e, "callee") && !Ct.call(e, "callee");
    }, se = Array.isArray;
    function ie(e) {
      return e != null && je(e.length) && !le(e);
    }
    function kr(e) {
      return F(e) && ie(e);
    }
    var xe = St || Ir;
    function le(e) {
      if (!R(e))
        return !1;
      var n = Z(e);
      return n == $ || n == w || n == y || n == Ke;
    }
    function je(e) {
      return typeof e == "number" && e > -1 && e % 1 == 0 && e <= u;
    }
    function R(e) {
      var n = typeof e;
      return e != null && (n == "object" || n == "function");
    }
    function F(e) {
      return e != null && typeof e == "object";
    }
    function Tr(e) {
      if (!F(e) || Z(e) != de)
        return !1;
      var n = ke(e);
      if (n === null)
        return !0;
      var a = O.call(n, "constructor") && n.constructor;
      return typeof a == "function" && a instanceof a && G.call(a) == kt;
    }
    var Ee = ye ? yt(ye) : Qt;
    function Cr(e) {
      return lr(e, Re(e));
    }
    function Re(e) {
      return ie(e) ? Zt(e) : er(e);
    }
    var Ar = cr(function(e, n, a, c) {
      Ie(e, n, a, c);
    });
    function Sr(e) {
      return function() {
        return e;
      };
    }
    function Le(e) {
      return e;
    }
    function Ir() {
      return !1;
    }
    o.exports = Ar;
  }(U, U.exports)), U.exports;
}
var In = Sn();
const $n = /* @__PURE__ */ An(In);
function On(o) {
  let t = {};
  function r(s, i) {
    if ((i == null ? void 0 : i.type) === "AwaitExpression" && i.argument.type === "CallExpression" && i.argument.callee.type === "Identifier" && i.argument.callee.name === "useStoryblok") {
      const l = i.argument.arguments;
      if (l && l[1].type === "ObjectExpression") {
        const u = qe(l[1].properties);
        t = {
          ...t,
          apiOptions: u
        };
      }
      if (l && l[2].type === "ObjectExpression") {
        const u = qe(l[2].properties);
        t = {
          ...t,
          bridgeOptions: u
        };
      }
    }
  }
  return $n({}, o, r), t;
}
function qe(o) {
  const t = {};
  return o.reduce((r, s) => {
    if (s.type !== "Property")
      return r;
    const { key: i, value: l } = s, { type: u } = l;
    if (i.type !== "Identifier")
      return r;
    if (u === "Literal")
      r[i.name] = l.value;
    else if (u === "ArrayExpression") {
      const f = l.elements.reduce(
        (g, y) => y.type === "Literal" && y.value ? [...g, y.value] : g,
        []
      );
      r[i.name] = f;
    }
    return r;
  }, t);
}
let B = [];
function xn(o, t) {
  const r = "virtual:storyblok-bridge", s = `\0${r}`;
  if (!o || t !== "server")
    return {
      name: "vite-plugin-storyblok-bridge",
      resolveId(f) {
        if (f === r)
          return s;
      },
      load(f) {
        if (f === s)
          return "export const bridgeOptions = null";
      }
    };
  let i = [], l = null, u;
  return {
    name: "vite-plugin-storyblok-bridge",
    async resolveId(f) {
      if (f === r)
        return s;
    },
    async transform(f, g) {
      var w;
      if (g.includes("node_modules") && !g.includes("/pages/") || !f.includes("useStoryblok"))
        return;
      const _ = this.getModuleInfo(g);
      if (!((w = _ == null ? void 0 : _.meta) != null && w.astro))
        return;
      const [, ...C] = g.split("src/pages/"), T = C.join("/").replace(".astro", ""), $ = On(this.parse(f));
      B.length && (i = B.filter((x) => x.url !== T)), i.push({
        url: T,
        options: $
      }), l && (u && clearTimeout(u), u = setTimeout(() => {
        jn(B, i) || (B.length !== 0 && (l == null || l.restart(), console.info("Bridge options updated. Restarting...")), B = [...i]);
      }, 1e3));
    },
    async load(f) {
      if (f === s)
        return `export const bridgeOptions = ${JSON.stringify(Cn(i))}`;
    },
    configureServer(f) {
      l = f;
    }
  };
}
function jn(o = [], t = []) {
  return t.every(({ url: r, options: s }) => {
    const i = o.find((l) => (l == null ? void 0 : l.url) === r);
    return i && JSON.stringify(s) === JSON.stringify(i.options);
  });
}
const En = `<svg width="45px" height="53px" viewBox="0 0 45 53" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="storyblok-logo-kit" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="storyblok-partner-logo" transform="translate(-59.000000, -169.000000)" fill-rule="nonzero">
            <g id="storyblok-symbol" transform="translate(59.000000, 169.000000)">
                <path d="M2.32662261,0 C1.03405449,0 0,1.0331384 0,2.27290448 L0,42.8752437 C0,44.1150097 1.03405449,44.8898635 2.27491989,44.8898635 L8.27243596,44.8898635 L8.27243596,53 L15.7176283,44.9415205 L42.9132615,44.9415205 C44.1541269,44.9415205 44.9296678,44.1666667 44.9296678,42.8752437 L44.9296678,2.3245614 C44.9296678,1.08479532 44.2058296,0 42.9132615,0 L2.32662261,0 Z" id="Shape-path-Copy" fill="#0AB3AF"></path>
                <path d="M29.1016723,8.11483254 C30.1351059,8.11483254 31.0135245,8.32132604 31.8402713,8.78593643 C32.6153465,9.19892344 33.33875,9.76678059 33.9071385,10.4378845 C35.0647615,11.8482391 35.6869248,13.6215753 35.6639755,15.445352 C35.6639755,16.7875598 35.3022738,18.0781442 34.630542,19.3171053 C33.9341248,20.5632996 32.8438147,21.5436614 31.5302412,22.1047676 C33.183735,22.569378 34.4755269,23.395352 35.4572888,24.5826897 C36.387379,25.8216507 36.8524241,27.4219754 36.8524241,29.4352871 C36.8524241,30.7258715 36.6168825,31.8756998 36.1290206,32.7391832 C35.6123039,33.668404 34.8372287,34.4427546 33.9071385,35.0106118 C32.9253766,35.6300923 31.8402713,36.1979494 30.600151,36.4560663 C29.3600307,36.7658066 28.0165671,37.0239234 26.6214318,37.0239234 L8.32965751,37.0239234 L8.32965751,8.11483254 L29.1016723,8.11483254 Z M26.1340815,24.271851 L15.77813,24.271851 L15.77813,29.1552028 L25.8851404,29.1552028 C26.4825991,29.1552028 27.0302696,28.9110352 27.4783637,28.5203671 C27.8766695,28.1296989 28.1256107,27.5436967 28.1256107,26.811194 C28.140051,26.1827412 27.948041,25.5663945 27.5779401,25.0531873 C27.1796343,24.5648522 26.7315403,24.271851 26.1340815,24.271851 Z M25.2876816,14.5051475 L15.77813,14.5051475 L15.77813,18.9001641 L25.0885287,18.9001641 C25.586411,18.9001641 26.0842933,18.6559965 26.4825991,18.3629954 C26.9306932,18.0699943 27.1298461,17.4351586 27.1298461,16.6049888 C27.1298461,15.872486 26.9306932,15.3353173 26.5821756,14.9934827 C26.233658,14.7004816 25.7855639,14.5051475 25.2876816,14.5051475 Z" id="Combined-Shape-Copy-3" fill="#FFFFFF"></path>
            </g>
        </g>
    </g>
</svg>`;
let Ge;
async function Nn(o) {
  const { action: t, story: r } = o || {};
  if (t === "input" && r) {
    const s = async () => {
      const l = await Ln(r), u = document.body;
      if (l.outerHTML === u.outerHTML)
        return;
      const f = document.querySelector('[data-blok-focused="true"]');
      Rn(u, l, f);
    };
    clearTimeout(Ge), Ge = setTimeout(s, 500);
  }
  ["published", "change"].includes(o == null ? void 0 : o.action) && location.reload();
}
function Rn(o, t, r) {
  if (r) {
    const s = r.getAttribute("data-blok-uid"), i = t.querySelector(
      `[data-blok-uid="${s}"]`
    );
    i && (i.setAttribute("data-blok-focused", "true"), r.replaceWith(i));
  } else
    o.replaceWith(t);
}
async function Ln(o) {
  const r = await (await fetch(location.href, {
    method: "POST",
    body: JSON.stringify({
      ...o,
      is_storyblok_preview: !0
    }),
    headers: {
      "Content-Type": "application/json"
    }
  })).text();
  return new DOMParser().parseFromString(r, "text/html").body;
}
function zn() {
  if (!(globalThis != null && globalThis.storyblokApiInstance))
    throw new Error("storyblokApiInstance has not been initialized correctly");
  return globalThis.storyblokApiInstance;
}
async function Fn(o, t = {}, r = {}, s) {
  var l;
  if (!globalThis.storyblokApiInstance)
    throw new Error("storyblokApiInstance has not been initialized correctly");
  let i = null;
  if (s && s.locals._storyblok_preview_data)
    i = s.locals._storyblok_preview_data;
  else {
    const { data: u } = await ((l = globalThis == null ? void 0 : globalThis.storyblokApiInstance) == null ? void 0 : l.get(
      o,
      t
    ));
    i = u.story;
  }
  return i;
}
function Dn(o, t) {
  var s;
  const r = (s = globalThis == null ? void 0 : globalThis.storyblokApiInstance) == null ? void 0 : s.richTextResolver;
  if (!r)
    throw new Error(
      "Please initialize the Storyblok SDK before calling the renderRichText function"
    );
  return Tn(o, t, r);
}
function Bn(o) {
  const t = {
    useCustomApi: !1,
    bridge: !0,
    componentsDir: "src",
    enableFallbackComponent: !1,
    livePreview: !1,
    ...o
  };
  return {
    name: "@storyblok/astro",
    hooks: {
      "astro:config:setup": ({
        injectScript: r,
        updateConfig: s,
        addDevToolbarApp: i,
        addMiddleware: l,
        config: u
      }) => {
        if (s({
          vite: {
            plugins: [
              $r(
                t.accessToken,
                t.useCustomApi,
                t.apiOptions
              ),
              Mr(
                t.componentsDir,
                t.components,
                t.enableFallbackComponent,
                t.customFallbackComponent
              ),
              Nr(t),
              xn(
                t.livePreview,
                u.output
              )
            ]
          }
        }), t.livePreview && (u == null ? void 0 : u.output) !== "server")
          throw new Error(
            "To utilize the Astro Storyblok Live feature, Astro must be configured to run in SSR mode. Please disable this feature or switch Astro to SSR mode."
          );
        if (r(
          "page-ssr",
          `
          import { storyblokApiInstance } from "virtual:storyblok-init";
          globalThis.storyblokApiInstance = storyblokApiInstance;
          `
        ), t.bridge && !t.livePreview) {
          let f = "";
          if (typeof t.bridge == "object") {
            const g = { ...t.bridge };
            f = `const storyblokInstance = new StoryblokBridge(${JSON.stringify(
              g
            )});`;
          } else
            f = "const storyblokInstance = new StoryblokBridge()";
          r(
            "page",
            `
              import { loadStoryblokBridge } from "@storyblok/astro";
              loadStoryblokBridge().then(() => {
                const { StoryblokBridge, location } = window;
                ${f}

                storyblokInstance.on(["published", "change"], (event) => {
                  if (!event.slugChanged) {
                    location.reload(true);
                  } 
                });
              });
            `
          );
        }
        t.livePreview && (r(
          "page",
          `
              import { loadStoryblokBridge, handleStoryblokMessage } from "@storyblok/astro";
              import { bridgeOptions }  from "virtual:storyblok-bridge";
              console.info("The Storyblok Astro live preview feature is currently in an experimental phase, and its API is subject to change in the future.")
              loadStoryblokBridge().then(() => {
                const { StoryblokBridge, location } = window;
                if(bridgeOptions){
                  const storyblokInstance = new StoryblokBridge(bridgeOptions);
                  storyblokInstance.on(["published", "change", "input"], handleStoryblokMessage);
                };
              });
            `
        ), l({
          entrypoint: "@storyblok/astro/middleware.ts",
          order: "pre"
        })), i({
          id: "storyblok",
          name: "Storyblok",
          icon: En,
          entrypoint: "@storyblok/astro/toolbarApp.ts"
        });
      }
    }
  };
}
export {
  mn as RichTextResolver,
  hn as RichTextSchema,
  Bn as default,
  Nn as handleStoryblokMessage,
  Mn as loadStoryblokBridge,
  Dn as renderRichText,
  Pn as storyblokEditable,
  Fe as toCamelCase,
  Fn as useStoryblok,
  zn as useStoryblokApi
};
